import {TipoMonedaDTO} from '../TipoMonedaDTO';

export class DatosInicioTotalesDTO
{
  esModoEResguardo: boolean;
  tiposMonedasDTOs: Array<TipoMonedaDTO>;
  codigoTipoMonedaSeleccionado: string;
  estaHabilitadoTipoCambio: boolean;
}
